import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {TranslationConfig} from '../translation.config';
import {Observable} from 'rxjs';
import {IObjectMap} from '../../models/IObjectMap';

@Injectable({
  providedIn: 'root'
})
export class ExtendedTranslateLoaderService extends TranslateLoader {
  private http = new HttpClient(this.httpBackend);
  private langs: IObjectMap<Observable<any>> = {};

  constructor(
    private httpBackend: HttpBackend,
    private config: TranslationConfig
  ) {
    super();
  }


  getTranslation(lang: string): any {
    if (!this.langs[lang]) {
      const url = `${this.config.apiUrl}/translations/safe-checkin/translations/${lang}`;
      console.log(`Generated url: ${url}`);
      this.langs[lang] = this.http.get(url);
    }

    return this.langs[lang];
  }
}
